import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class RestProvider {
  public buh = "3";
  projects(companyId: string) {
    throw new Error("Method not implemented.");
  }
  // static HOST = 'http://localhost/';
  // static PREFIX = 'http://localhost/cow-back-end/index.php/cows';
  static HOST = 'https://cowfarm.susano-tech.mn/';
  static PREFIX = 'https://cowfarm.susano-tech.mn/cow-back-end/index.php/cows';


  constructor(public http: HttpClient) {
  }
  
  public login(loginId: string, password: string, farm: any): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/login/', {email: encodeURIComponent(loginId), password: password, farm_id: farm});
  }
  public InsertCow(
    farm: any, 
    Cow_Code: any, 
    Mother_Code: any, 
    Father_Code: any, 
    Cow_Name: string, 
    Birth_Date: Date, 
    Sex: any, 
    Cow_Type: any, 
    Cow_Status: any,
    Cow_Image: string,
    Sim_Status_ID: string, 
    Status_Start_Date: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/insertCows/', {
      farm_id: farm,
      cow_code: Cow_Code,
      mother_id: Mother_Code,
      father_id: Father_Code,
      cow_name: Cow_Name,
      birth_date: Birth_Date,
      sex: Sex,
      cow_type: Cow_Type,
      cow_status: Cow_Status,
      cow_image: Cow_Image,
      sim_status_id: Sim_Status_ID,
      status_start_date: Status_Start_Date
    });
  }
  public farms(): Observable<any> {
    return this.http.get(RestProvider.PREFIX + '/getFarms/');
  }
  public CowTypes(): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getTypes/', {});
  }
  public CowStatuses(): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getStatuses/', {});
  }
  public CowGender(): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getGender/', {});
  }
  public CowBull(): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getBull/', {});
  }
  public CowMother(): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getMother/', {});
  }
  public Cows(farm: any): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getCows/', {farm_id: farm});
  }
  public QRSCANNER(Cow_Code: any): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getQR/', {cow_code: Cow_Code});
  }
  public InsertWeight(user_id, Cow_Code, date, Cow_Weight, Cow_Temperature, Cow_Height): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/insertWeight/', {
      user_id: user_id,
      cow_code: Cow_Code,
      date: date,
      cow_weight: Cow_Weight,
      cow_temperature: Cow_Temperature,
      cow_height: Cow_Height
    });
  }
  public DeleteCows(Cow_id: any): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/deleteCows/', {cow_id: Cow_id});
  }
  
  public notifications_weight_unincluded(Farm_id: any): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/notifications/', {farm_id: Farm_id});
  }
  public notifications_weight_included(Farm_id: any): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/weight_included/', {farm_id: Farm_id});
  }

  
  public UpdateCowsGet(Cow_id: any): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getCowUpdate/', {cow_id: Cow_id});
  }
  public UpdateCows(Cow_id: any,farm: any, Cow_Code: string, Cow_Name: string, Birth_Date: Date, Sex: any, Cow_Type: any, Cow_Status: any, Cow_Image: any, Sim_Status_ID: string, Status_Start_Date: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/updateCows/', {
      cow_id: Cow_id,
      farm_id: farm,
      cow_code: Cow_Code,
      cow_name: Cow_Name,
      birth_date: Birth_Date,
      sex: Sex,
      cow_type: Cow_Type,
      cow_status: Cow_Status,
      cow_image: Cow_Image,
      sim_status_id: Sim_Status_ID,
      status_start_date: Status_Start_Date
    });
  }
  public CowCode(COW_CODE: any): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getWeight/', {cow_code: COW_CODE});
  }

  public UploadImage(file: any): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/do_upload/', file);
  }
  public StartSim(uher_em: string, uher_er: string, honog: string, mode: boolean, farm_group: any): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/StartSim/', {
      uher_em: uher_em,
      uher_er: uher_er,
      honog: honog,
      mode: mode,
      farm_group: farm_group
    });
  }
  public simMasterTable(): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/simMaster/', {});
  }
  public SeasonsMaster(): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/seasons/', {});
  }
  public simMasterUpdate(id: string, type: string, status: string, nextstatus: string, isnewitem: string,statusname: string, minval: string, maxval: string, ows: string, tejeel: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/simMasterUpdate/', {
      id: id,
      type: type,
      status: status,
      nextstatus: nextstatus,
      isnewitem: isnewitem,
      statusname: statusname,
      minval: minval,
      maxval: maxval,
      ows: ows,
      tejeel: tejeel
    });
  }
  public seasonUpdate(id: string, season_name: string, season_start_date: string, season_end_date: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/seasonUpdate/', {
      id : id,
      season_name : season_name,
      season_start_date : season_start_date,
      season_end_date : season_end_date
    });
  }
  public insertSeason(season_name: string, season_start_date: string, season_end_date: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/insertSeason/', {
      name : season_name,
      start_date : season_start_date,
      end_date : season_end_date
    });
  }
  public seasonDelete(id: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/seasonDelete/', {
      id : id,
    });
  }

  public Base64ToFile(FileName: string, Base64: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/du_uploads/', {
      filename : FileName,
      base64 : Base64,
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/rest/rest.ts